import { AdobeTracking, TrackingService } from '@repo/roche-xx-shared';
import { RocheUIAudioEvent } from '@rocheglobal/roche-ui';

export type TrackedPercentage = Record<number, boolean>;

export const rocheAudioTracking = (event: RocheUIAudioEvent): void => {
  switch (event.type) {
    case 'starting':
      trackStartEvent(event);
      break;
    case 'completed':
      trackCompletedEvent(event, event.base.audioPercentage);
      break;
    case 'progress':
      trackProgressEvent(event, event.base.audioPercentage);
      break;

    case 'error': {
      trackAudioError(event, event.errorMessage);
      break;
    }
  }
};

const getDefaultTrackingData = (event: RocheUIAudioEvent) => {
  return {
    event: 'audio_tracking',
    component_name: 'roche-audio',
    additionalParameters: {
      name: event.base.audioName,
      url: event.base.audioUrl,
      provider: event.base.audioProvider,
      durationTotal: event.base.audioDurationTotal,
      progress: event.base.audioPercentage,
    },
  };
};

const getDefaultAdobeTrackingData = (event: RocheUIAudioEvent) => {
  return {
    name: event.base.audioName,
    url: event.base.audioUrl,
    provider: event.base.audioProvider,
    durationTotal: event.base.audioDurationTotal,
  };
};

export const trackStartEvent = (event: RocheUIAudioEvent) => {
  const defaultTrackingData = getDefaultTrackingData(event);
  const defaultAdobeTrackingData = getDefaultAdobeTrackingData(event);

  TrackingService.push({
    ...defaultTrackingData,
    value: event.trackingValue,
  });

  AdobeTracking(
    {
      ...defaultAdobeTrackingData,
    },
    event.trackingValue,
  );
};

export const trackProgressEvent = (event: RocheUIAudioEvent, podcastPercentage: number) => {
  const defaultTrackingData = getDefaultTrackingData(event);
  const defaultAdobeTrackingData = getDefaultAdobeTrackingData(event);

  TrackingService.push({
    ...defaultTrackingData,
    value: event.trackingValue,
  });

  AdobeTracking(
    {
      ...defaultAdobeTrackingData,
      progress: podcastPercentage,
    },
    event.trackingValue,
  );
};

export const trackCompletedEvent = (event: RocheUIAudioEvent, podcastPercentage: number) => {
  const defaultTrackingData = getDefaultTrackingData(event);
  const defaultAdobeTrackingData = getDefaultAdobeTrackingData(event);

  TrackingService.push({
    ...defaultTrackingData,
    value: event.trackingValue,
  });

  AdobeTracking(
    {
      ...defaultAdobeTrackingData,
      progress: podcastPercentage,
    },
    event.trackingValue,
  );
};

export const trackAudioError = (event: RocheUIAudioEvent, errorMessage: string) => {
  const defaultAdobeTrackingData = getDefaultAdobeTrackingData(event);

  AdobeTracking(
    {
      ...defaultAdobeTrackingData,
      error: errorMessage,
    },
    event.trackingValue,
  );
};
